import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';

import Blocks from '../blocks/Blocks';

import styles from '../../../styles/pages/page.scss';

const propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func,
    }).isRequired,
    page: PropTypes.shape({
        data: PropTypes.shape({
            blocks: PropTypes.array,
        }),
    }).isRequired,
};

const Page = ({ intl, page }) => (
    <div className={styles.container}>
        <Helmet>
            <title>
                {intl.formatMessage({
                    id: 'meta.title_page',
                    defaultMessage: 'Accueil',
                }, {
                    title: get(page, 'title', ''),
                })}
            </title>
        </Helmet>
        <div
            className={classNames({
                [styles.section]: true,
                [styles.blocks]: true,
            })}
        >
            <Blocks
                items={get(page, 'data.blocks', []).map((block, index) => ({
                    ...block,
                    first: index === 0,
                }))}
                withFirst
            />
        </div>
    </div>
);

Page.propTypes = propTypes;

const mapStateToProps = ({ site, layout }, { location }) => ({
    ...layout.size,
    page:
        site.page !== null && site.page.url === location.pathname
            ? site.page
            : site.pages.find(it => it.url === location.pathname) || null,
});
const WithStateContainer = connect(mapStateToProps)(Page);
const WithIntlContainer = injectIntl(WithStateContainer);
const WithRouterContainer = withRouter(WithIntlContainer);

export default WithRouterContainer;



// WEBPACK FOOTER //
// ./js/components/pages/Page.jsx